import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../../components/layout'
import Seo from '../../components/seo'
import JobTypeMain from '../../components/jobtype/main'

const JobTypeListTemplate = ({ data }) => {
	return (
		<Layout active='careers'>
			<Seo title='Jobtypes' />
			<JobTypeMain data={data} />
		</Layout>
	)
}

export default JobTypeListTemplate

export const query = graphql`
	query JobTypeTemplate($strapiId: Int!, $careerId: Int!, $programIds: [Int], $today: Date!) {
		strapiJobtype(strapiId: { eq: $strapiId }) {
			id
			strapiId
			Title
			Description
			Demand {
				id
				Title
				Icon
			}
			Salarylevel {
				id
				Title
				Icon
			}
			Programs {
				id
				Title
			}
			Specialties
			Testimonygiver
			Testimonytext
			Testimonyvideo
			Keytasks
		}
		strapiCareer(strapiId: { eq: $careerId }) {
			Title
			Image {
				file {
					childImageSharp {
						gatsbyImageData(width: 1920, layout: CONSTRAINED)
					}
				}
			}
		}
		allStrapiJob(filter: { Jobtype: { strapiId: { eq: $strapiId } }, Due_date: { gte: $today } }) {
			edges {
				node {
					strapiId
					Title
				}
			}
		}
		allStrapiProgram(filter: { strapiId: { in: $programIds } }) {
			edges {
				node {
					id
					strapiId
					Title
				}
			}
		}
		allStrapiInstitution(filter: { Programs: { elemMatch: { strapiId: { in: $programIds } } } }) {
			edges {
				node {
					id
					strapiId
					Title
					Programs {
						id
						Title
					}
					Href {
						id
						Url
					}
				}
			}
		}
	}
`
